import './Callout.css';

export const Callout = ({ children, className = '' }) => {
  return (
    <div className={`callout ${className}`.trim()}>
      {children}
    </div>
  );
};

